import { render, staticRenderFns } from "./functionpage.vue?vue&type=template&id=6c1d388a"
import script from "./functionpage.vue?vue&type=script&lang=js"
export * from "./functionpage.vue?vue&type=script&lang=js"
import style0 from "./functionpage.vue?vue&type=style&index=0&id=6c1d388a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports